export class ResultadoLoteriaFederacaoModel {
  public seqResultadoLoteriaFederal: number;
  public numExtracao: number;
  public dataExtracao: Date;
  public numPrimeiroPremio: number;
  public numSegundoPremio: number;
  public numTerceiroPremio: number;
  public numQuartoPremio: number;
  public numQuintoPremio: number;
  public dataAtualizacao: Date;
}



// WEBPACK FOOTER //
// ./src/app/shared/model/resultado-loteria-federal.model.ts